module.exports = __webpack_public_path__ + "static/media/pp-4.f6911209.jpg";